export default class Country {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        countryRetrieve(id: ${id}) {
          id
          name
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.countryRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        countryList {
          results {
            id
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.countryList.results;
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteCountry(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteCountry.ok;
  }

  static async create(axios, name) {

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createCountry(newCountry: {
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCountry.ok;
  }


  static async edit(axios, id, name) {

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCountry(newCountry: {
          id: ${id},
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCountry.ok;
  }


}
